import React, { useEffect, useState } from 'react';
import Formbusqueda from './Formbusqueda';
import { CallApiPost, CallApiGet } from '../../apicalls/calls.js';
import { setLiquidacion, selectLiquidacion } from '../../slice/global';
import { useSelector, useDispatch } from 'react-redux';

export default function Liquidacion() {
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const [principalC, SetprincipalC] = useState(true);
    const [configM, SetconfigM] = useState({});
    const TablaLiquidacion = useSelector(selectLiquidacion);
    const dispatch = useDispatch();
    const [disableb,Setdisableb]=useState(true);
    const [users, SetUsers] = useState([]);
    const [valuesf, setValuesF] = useState({
        usuario: '',
        f_inicio: '',
        f_fin: ''
    });
    const [total, SetTotal] = useState(0);
    const [totals, SetTotals] = useState('');
    useEffect(() => {
        fetchData();
    }, []);

    function GetTotal(array) {
        let sum = 0;
        //console.log("ArraySum", array)
        array.forEach(element => {
            if (element.check) {
                sum += element.liquidacion;
            }
        });
        SetTotal(sum);
        SetTotals(sum.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }));
        //console.log("correccion",sum.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }));
    }

    //Metodo para hacer la llamada a la API
    async function fetchData() {
        $("#backdrop").show();
        var params = { id_usuario: UsuarioS.user.id, tipo:'Liquidaciones' };
        const Call = await CallApiGet('getAllUserByUser', params, UsuarioS.access_token);
        SetUsers(Call.success.users);
        //Call.success.UserMargen.margen=0;
        SetconfigM(Call.success.UserMargen);
        GetTotal([])
        $("#backdrop").hide();
    }

    //busqueda de la tabla
    async function Search(values, actions) {
        $("#backdrop").show();
        //setValuesF(values);
        var val = { ...values };
        val.id_usuario = UsuarioS.user.id;
        val.tipo_usuario = UsuarioS.user.tipo_usuario;
        let iduser = users.map((item) => (item.id));
        val.usuarios = iduser;
        //val.usuario=UsuarioS.user.id;
        //console.log("valuesform", val);
        const Call = await CallApiGet('getLiquidacionTabla', val, UsuarioS.access_token);
        //console.log("resCall", Call);
        setValuesF(val);
        dispatch(setLiquidacion(Call.success.sorteos));
        GetTotal(Call.success.sorteos);
        $("#backdrop").hide();
    }

    function ChangeUser() {
        dispatch(setLiquidacion([]));
    }

    function getTipo(tipo) {
        let t = '';
        switch (tipo) {
            case 1:
                t = "Administrador"
                break;
            case 2:
                t = "Cooperativa"
                break;
            case 3:
                t = "Corredor"
                break;
        }
        return t;
    }

    function reset() {
        dispatch(setLiquidacion([]));
        GetTotal([]);
    }

    function OnChangeCheck(index) {
        //let copy=TablaLiquidacion;
        let copy = JSON.parse(JSON.stringify(TablaLiquidacion));
        //console.log("copy", copy[index]);
        copy[index].check = !copy[index].check;
        //console.log(copy);
        dispatch(setLiquidacion(copy));
        GetTotal(copy);
        /* copy[index].check=true;
        dispatch(setLiquidacion(copy));
        GetTotal(copy); */
    }

    async function Liquidar() {
        //alert('liquidar');
        $("#backdrop").show();
        var selectedUsr = $("#usuario").val();
        const fechas = TablaLiquidacion.map((item) => {
            if (item.check && item.corredor != null) {
                return item.fecha;
            }
        });
        var idsaldos = TablaLiquidacion.map((item) => {
            if (item.check && item.corredor != null) {
                return item.corredor;
            }
        });
        //console.log("usuario send", UsuarioS.user.id);
        var params = { id_usuario: selectedUsr, tipo_usuario: UsuarioS.user.tipo_usuario, fechas: fechas, id_registros: idsaldos, usuario: UsuarioS.user.id };
        const Call = await CallApiPost('postLiquidacion', params, UsuarioS.access_token);
        if (Call.status != 200) {
            alert("error al momento de guardar");
        } else {
            const Call = await CallApiGet('getLiquidacionTabla', valuesf, UsuarioS.access_token);
            dispatch(setLiquidacion(Call.success.sorteos));
            GetTotal(Call.success.sorteos);
        }
        $("#backdrop").hide();
    }

    async function LiquidarNew() {
        $("#backdrop").show();
        var selectedUsr = $("#usuario").val();
        let tbl = TablaLiquidacion.filter((item) => item.check === true);
        var params = { id_usuario: selectedUsr, tipo_usuario: UsuarioS.user.tipo_usuario, usuario: UsuarioS.user.id, tabla: tbl };
        //console.log(tbl);
        const Call = await CallApiPost('postLiquidacion', params, UsuarioS.access_token);
        if (Call.status != 200) {
            $("#backdrop").hide();
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: Call.error.message,
            });

        } else {
            const Call = await CallApiGet('getLiquidacionTabla', valuesf, UsuarioS.access_token);
            dispatch(setLiquidacion(Call.success.sorteos));
            GetTotal(Call.success.sorteos);
            $("#backdrop").hide();
        }
    }

    function Onchange(e, index) {
        const { value } = e.target;
        let state = JSON.parse(JSON.stringify(TablaLiquidacion));
        if (state[index].totalFinal < parseFloat(value)) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "El valor no puede mayor.",
            });
            return;
        }
        if (parseFloat(value) <= 0) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "El valor no puede ser menor o igual a 0.",
            });
            return;
        }
        state[index].liquidacion = parseFloat(value);
        dispatch(setLiquidacion(state));
        GetTotal(state);

    }

    const ValidateUser=(value)=>{
        if(value=='')
            Setdisableb(false);
        if(parseInt(value)==UsuarioS.user.id)
            Setdisableb(false);
        else
            Setdisableb(true);
    }

    const PrincipalCheck = (value) => {
        let cpy = JSON.parse(JSON.stringify(TablaLiquidacion));;
        //console.log("copia",cpy);
        cpy.forEach((elem) => elem.check = value);
        SetprincipalC(value);
        dispatch(setLiquidacion(cpy));
        GetTotal(cpy);
        //console.log("tabla",cpy);
        //dispatch(setLiquidacion(cpy));

    }

    return (
        <div className='container-fluid'>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Liquidación</h1>
                {UsuarioS.user.tipo_usuario < 3 && (
                    <>
                        {/* 
                    https://api.ticc.com.mx/api/getEstadoCuenta/
                    http://localhost/qa.lumen/api/getEstadoCuenta
                    <a  href={`${process.env.URLAPI}getEstadoCuenta/${UsuarioS.user.id}`} target="_blank"
                        className="d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        Reporte de liquidaciones
                    </a> */}
                        <a href={`${process.env.URLAPI}getEstadoCuenta3?usuario=${UsuarioS.user.id}&fechaI=${valuesf.f_inicio}&fechaF=${valuesf.f_fin}&usuarioF=${valuesf.usuario}`} target="_blank"
                            className="d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            Reporte de liquidaciones
                        </a>
                    </>
                )}
            </div>
            {configM.margen==0 && (
                <div className="row">
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className="alert alert-danger" style={{ fontSize: "16px" }} role="alert">
                            Su usuario no tiene configurado ningún margen, contacte con el administrador.
                        </div>
                    </div>
                </div>
            )}
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Registros</h6>
                </div>
                <div className='card-body'>
                    <Formbusqueda Users={users} Search={Search} ChangeUser={ChangeUser} Reset={reset} Usuario={UsuarioS.user} ValidateUser={ValidateUser} />
                    <div className='table-responsive'>
                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th width={'50px'}>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" checked={principalC} value={principalC} onChange={() => PrincipalCheck(!principalC)} id="flexCheckDefault" />
                                        </div>
                                    </th>
                                    <th>Sorteo</th>
                                    <th>Nombre</th>
                                    <th>Tipo</th>
                                    <th>Fecha</th>
                                    <th>Total</th>
                                    <th>Comision</th>
                                    <th>Pagado</th>
                                    <th>Saldo</th>
                                    <th>Liquidar</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '12px' }}>
                                {TablaLiquidacion.length == 0 && (
                                    <tr>
                                        <td className='text-center' colSpan={10}>No hay registros en la tabla</td>
                                    </tr>
                                )}
                                {TablaLiquidacion && TablaLiquidacion.map((item, key) => (
                                    <tr key={key}>
                                        <td><input type="checkbox" checked={item.check} disabled={item.disabled} onChange={() => OnChangeCheck(key)} /></td>
                                        <td>{item.sorteo_nombre}</td>
                                        <td>{item.nombre}</td>
                                        <td>{getTipo(item.tipo_usuario)}</td>
                                        <td>{/* item.fecha */window.moment(item.fecha).locale('es-mx').format('L')}</td>
                                        <td>${item.saldo}</td>
                                        <td>${item.comision}</td>
                                        <td>${item.pagado != null ? item.pagado : 0}</td>
                                        <td>${item.totalFinal}</td>
                                        <td width={'150px'}>{item.check && UsuarioS.user.tipo_usuario <= 2 ? <input className='form-control numeric' type="number" value={item.liquidacion} onChange={(e) => Onchange(e, key)} /> : `$${item.liquidacion}`}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                    <div className='row'>
                        <div className='text-right'>
                            <h5>  Total a liquidar: {/*  ${total} | */}{totals}</h5>
                            <br />
                            {UsuarioS.user.tipo_usuario < 3 && disableb && (
                                <button className='btn btn-primary' onClick={() => LiquidarNew()} disabled={TablaLiquidacion.length == 0 ? true : false}>Liquidar</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
